/**
 * Which backend is this bundle actually talking to?
 *
 * With two Firebase projects — `rendimees24-dev` for testing and
 * `rendimees24-prod` for customers — the dangerous failure is not a crash. It
 * is a page that looks completely normal while reading and writing the WRONG
 * database: a prod Hosting deploy built against `.env.development`, or a
 * dev tab left open next to a live one while you enter real invoice data.
 *
 * Nothing about the UI reveals which is which, so the project id is promoted
 * here into an explicit, greppable answer that `EnvBadge` renders and
 * `scripts/deploy.sh` verifies against the deployed bundle after every deploy.
 *
 * The value comes from `VITE_FIREBASE_PROJECT_ID`, written by
 * `scripts/sync-expo-env.sh` from the matching `.env.<stage>` — the same
 * variable `services/firebase.ts` initialises the SDK with, so this can never
 * disagree with the connection it describes.
 */

export const FIREBASE_PROJECT_ID = import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '';

/** The live project. Everything else is a test tier and says so on screen. */
export const PRODUCTION_PROJECT_ID = 'rendimees24-prod';

export const IS_PRODUCTION = FIREBASE_PROJECT_ID === PRODUCTION_PROJECT_ID;

/** The test project. Gates internal-only surfaces (dev role-switcher, Tegevuskava). */
export const DEV_PROJECT_ID = 'rendimees24-dev';

export const IS_DEV_PROJECT = FIREBASE_PROJECT_ID === DEV_PROJECT_ID;

/**
 * Short label for the environment ribbon. Deliberately `null` on production —
 * a badge that shows on the live site is noise customers should never see.
 */
export function environmentLabel(): string | null {
  if (IS_PRODUCTION) return null;
  if (!FIREBASE_PROJECT_ID) return 'NO CONFIG';
  if (FIREBASE_PROJECT_ID === 'rendimees24-dev') return 'TEST';
  return FIREBASE_PROJECT_ID;
}
